import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "text-center p-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Mol2DView = _resolveComponent("Mol2DView");
    const _component_Popup = _resolveComponent("Popup");
    return (_openBlock(), _createElementBlock("div", {
        ref: "smilesPopupViewerContainer",
        class: "smiles-popup-viewer-container mb-4",
        style: _normalizeStyle(_ctx.containerStyles)
    }, [
        _createElementVNode("span", {
            style: _normalizeStyle({ cursor: _ctx.inPopup || !_ctx.smilesToUse ? 'default' : 'pointer' })
        }, [
            (_ctx.isIntersecting && _ctx.smilesToUse)
                ? (_openBlock(), _createBlock(_component_Mol2DView, {
                    key: 0,
                    smiles: _ctx.smilesToUse,
                    maxHeight: _ctx.maxHeight,
                    drawingWidth: _ctx.measuredContainerWidth > 0 ? _ctx.measuredContainerWidth : undefined,
                    minHeight: 30,
                    onClick: _ctx.onClick
                }, null, 8, ["smiles", "maxHeight", "drawingWidth", "onClick"]))
                : (!_ctx.isIntersecting && _ctx.smilesToUse)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        style: _normalizeStyle({ minHeight: (_ctx.maxHeight ? Math.min(_ctx.maxHeight, 50) : 50) + 'px', width: '100%' })
                    }, null, 4))
                    : _createCommentVNode("", true)
        ], 4),
        (!_ctx.inPopup)
            ? (_openBlock(), _createBlock(_component_Popup, {
                key: 0,
                modelValue: _ctx.showSmilesPopup,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.showSmilesPopup) = $event)),
                title: "Molecular Structure",
                cancelBtnTxt: "Close",
                id: "molStructurePopupForSmiles"
            }, {
                default: _withCtx(() => [
                    (_ctx.showSmilesPopup && _ctx.smilesToUse)
                        ? (_openBlock(), _createBlock(_component_Mol2DView, {
                            key: 0,
                            smiles: _ctx.smilesToUse,
                            drawingWidth: 450,
                            drawingHeight: 350,
                            minHeight: 50,
                            showDownloadButtons: true
                        }, null, 8, ["smiles"]))
                        : (_ctx.showSmilesPopup && !_ctx.smilesToUse)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, " No SMILES string provided for popup view. "))
                            : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
    ], 4));
}
